import { Box, Button, Grid, makeStyles, TextField } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect } from "react";
import { Controller, useFieldArray, useWatch } from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MovieSuggestionDropdown from "../MovieSuggestionDropdown";

const useStyles = makeStyles((theme) => ({
  movieBlk: {
    background: "#FFFFFF",
    marginBottom: "20px",
  },
  movieBlkHeader: {
    background: "#EDEEF0",
    borderLeft: "3px solid #306F9D",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    padding: "12px 13px",
  },
  movieBlkBody: {
    border: "1px solid #CCCCCC",
    borderTop: "0px",
    padding: "20px 13px",
  },
  deleteBtn: {
    margin: "0",
    padding: "0",
    minWidth: "initial",
  },
}));

export default function MovieSections({ disabled, ...props }) {
  const {
    control,
    language,
    setValue,
    getValues,
    setLoading,
    setFieldsSnapshot,
  } = props;
  const classes = useStyles();
  const { fields, remove, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "movieList", // unique name for your Field Array
      // keyName: "id", default to "id", you can change the key name
    }
  );
  const movieList = useWatch({
    control,
    name: "movieList",
  });

  const [isRemoved, setIsRemoved] = React.useState(false);

  const addNewMovie = React.useCallback(() => {
    insert(fields.length, {
      title: "",
      order: fields.length,
    });
  }, [insert, fields]);

  useEffect(() => {
    //Forced update 1st time - may not have enough time to update the data manually
    if (isRemoved) {
      setFieldsSnapshot(fields);
      setValue("movieList", fields);
      setIsRemoved(false);
      //Forced update 2nd time - in the parent component
      setLoading(true);
    }
  }, [isRemoved]);

  // console.log({ movieList });

  // useEffect(()=>{
  //   setTimeout(()=>{
  //     addNewMovie();
  //   },0)
  //   setTimeout(()=>{
  //     remove(fields.length-1);
  //   },1)
  // }, [])

  return (
    <>
      {fields.map((field, index) => (
        <div className={classes.movieBlk} key={field.id}>
          <Grid
            container
            className={classes.movieBlkHeader}
            xs={12}
            alignItems="center"
            justify="space-between"
          >
            <span>Movie {index + 1}</span>
            {disabled || (
              <Button
                className={classes.deleteBtn}
                onClick={() => {
                  remove(index);
                  setTimeout(() => setIsRemoved(true), 0);
                }}
              >
                <Close style={{ fontSize: "14px", lineHeight: "16px" }} />
              </Button>
            )}
          </Grid>
          <Box className={classes.movieBlkBody}>
            <Grid container spacing={3} direction="column">
              <Grid container item xs={12} spacing={3}>
                <Grid container item xs={6} direction="column">
                  <Grid item>Movie</Grid>
                  <Grid item>
                    <MovieSuggestionDropdown
                      index={index}
                      control={control}
                      setValue={setValue}
                      defaultValue={fields[index] && fields[index]}
                      language={language}
                      getValues={getValues}
                      movieList={movieList}
                      disabled={disabled}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={6} direction="column">
                  <Grid item>Order</Grid>
                  <Grid item>
                    <Controller
                      defaultValue={fields[index] && fields[index].order}
                      name={`movieList.${index}.order`}
                      control={control}
                      type="number"
                      rules={{ required: "Required" }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          type="number"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          error={!!error}
                          helperText={error ? error.message : ""}
                          {...field}
                          onWheel={(e) => e.target.blur()}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </div>
      ))}
      {disabled || (
        <Button
          onClick={addNewMovie}
          style={{
            color: "#306F9D",
            margin: "5px 0",
          }}
        >
          <AddCircleIcon />
          Add Movie
        </Button>
      )}
    </>
  );
}
